import {
    PropsWithChildren,
    ReactNode,
    useEffect,
    useState,
    ReactElement,
} from 'react';
import clsx from 'clsx';
import {CancelIcon} from '../icons';
import * as styles from './modal.module.css';

interface IModal {
    buttons?: ReactNode,
    title: ReactElement | string | null,
    closeModal: () => void,
    isSuccess?: boolean,
    classNames?: {
        root?: string,
        modal?: string,
        title?: string,
    },
    className?: string,
}

const Modal = ({
    children,
    buttons,
    title,
    closeModal,
    isSuccess,
    classNames,
    className,
}: PropsWithChildren<IModal>) => {
    const [isClosing, setIsClosing] = useState(false);

    const handleOnClose = () => {
        setIsClosing(true);

        document.body.dataset.modalOpen = 'false';

        setTimeout(() => {
            closeModal();
        }, 200);
    };

    useEffect(() => {
        document.body.dataset.modalOpen = 'true';

        return () => {
            document.body.dataset.modalOpen = 'false';
        };
    }, []);

    return (
        <div
            className={clsx(
                styles.root,
                isClosing && styles.isClosing,
                className,
            )}
        >
            <div
                className={clsx(
                    styles.modal,
                    isClosing && styles.isClosing,
                    classNames?.modal,
                )}
            >
                <div className={styles.modalContent}>
                    <button className={styles.close} onClick={handleOnClose}>
                        <CancelIcon/>
                        <span>Close</span>
                    </button>
                    {title && (
                        <div className={clsx(styles.title, classNames?.title)}>
                            {title}
                        </div>
                    )}
                    {children}
                    {buttons && (
                        <div className={styles.buttons}>
                            {buttons}
                        </div>
                    )}
                </div>
                {isSuccess && (
                    <img
                        className={styles.success}
                        alt="success"
                        src="/images/modal/modal-success.png"
                    />
                )}
            </div>
        </div>
    );
};

export default Modal;
